import { Section } from 'components/grid'
import React from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import IRLAStarterKits from 'components/intervention/IRLAStarterKits'

export default function IRLAStarterKit({ ...props }) {
	return (
		<Section id={formatSectionId(props)} className="mt-20 scroll-mt-14">
			<IRLAStarterKits showFrameworks />
		</Section>
	)
}
